import React from "react";

import { Button, Icon, Paragraph, Title } from "@sicredi/react";
import { Link } from "#/components/Link";
import { GATEWAY_URL } from "#/constants";
import ResponsiveSpacing from "#/components/ResponsiveSpacing";

export const NoPlans: React.FC = () => {
  return (
    <div style={{ textAlign: "center" }} data-testid="no-plans">
      <ResponsiveSpacing />
      <Icon appearance="primary" size={104} name="satisfaction-dissatisfied" />
      <ResponsiveSpacing />
      <Title as="h3">Você não possui planos contratados</Title>
      <ResponsiveSpacing />
      <Paragraph>
        Clique no botão a seguir para conhecer nossos planos de telemedicina e
        odontológicos.
      </Paragraph>
      <ResponsiveSpacing />
      <Button
        as={Link}
        to={GATEWAY_URL()}
        appearance="link"
        data-testid="btn-plans"
      >
        Conhecer planos
        <Button.Icon>
          <Icon name="chevron-right" />
        </Button.Icon>
      </Button>
    </div>
  );
};

export default NoPlans;
